module.exports = __webpack_public_path__ + "img/线下见面会-detail.ac5eecd4.png";